<template>
    <zen-message-modal :isOpen="isOpen" title="Remove value?">
        Are you sure you want to remove this value? Once removed it is
        immediately unavailable and will not be returned to your applications
        from the API.
        <template v-slot:buttons>
            <zen-button variant="primary-danger" @click="$emit('confirm')">
                Remove
            </zen-button>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RemoveFlagValueModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
